<template>
  <v-menu
    min-width="450px"
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn :small="small" icon v-on="{...on, ...onTooltip}" :disabled="readonly">
            <v-icon :small="small" :color="iconColor">mdi-paperclip</v-icon>
          </v-btn>
        </template>
        <span>{{ labelTooltip }}</span>
      </v-tooltip>
    </template>
    <v-card class="mx-auto">
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <px-anexo badge-color="primary"
                      :read-only="readonly"
                      v-model="produto.arquivos"
                      :max="5"
                      top
                      :bottom="false"
                      downloadBasePath="files/download-comprador"
                      @loading="onFileLoad">
              <template v-slot:activator="{ on }">
                <v-btn small depressed
                       class="rounded-tag-small elevation-0"
                       color="" v-on="on">
                  Adicionar anexo
                </v-btn>
              </template>
            </px-anexo>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              outlined
              auto-grow
              class="rounded-tag-small"
              label="Observação interna"
              counter="1500"
              rows="3"
              :disabled="readonly"
              v-model="produto.observacaoInterna"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              outlined
              auto-grow
              class="rounded-tag-small"
              label="Observação externa"
              counter="1500"
              rows="3"
              :disabled="readonly"
              v-model="produto.observacaoExterna"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-btn @click="onClickConcluir" color="primary"
                   class="rounded-tag-small normal-btn-text elevation-0">
              Concluir
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    produto: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    isEdicao: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    iconColor() {
      if (this.produto.observacaoExterna
        || this.produto.observacaoInterna || this.produto.arquivos.length) {
        return 'primary';
      }
      return '';
    },
    labelTooltip() {
      return this.isEdicao ? 'Editar observações e anexos' : 'Adicionar observações e anexos';
    },
  },
  methods: {
    onFileLoad(loading) {
      this.$emit('file-loading', loading);
    },
    onClickConcluir() {
      this.opened = false;
    },
  },
};
</script>
